import logo from "../../assets/icon_1024.png";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { usePrivacy } from "../../context/PrivacyContext";
import { c } from "../../content";
import { SITE } from "../../site";

const SOCIALS = [
  { label: "LinkedIn · Miłosz", href: SITE.socials.linkedinMilosz },
  { label: "LinkedIn · Dominika", href: SITE.socials.linkedinDominika },
];

export default function Footer() {
  const { lang } = useLang();
  const { openPolicy } = usePrivacy();

  return (
    <footer className="bg-navy-deep relative overflow-hidden" data-testid="footer">
      <div className="relative overflow-hidden pt-14 pb-0 pointer-events-none select-none" aria-hidden="true">
        <p
          className="font-display font-light text-center leading-none tracking-[0.1em]"
          style={{ fontSize: "clamp(4rem, 12vw, 11rem)", color: "rgba(242,232,216,0.03)" }}
        >
          PRZESTRZEŃ
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-20 pt-4 pb-16 grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">

        <div>
          <a href="/#top" className="inline-flex items-center gap-3 mb-6 group">
            <span
              className="overflow-hidden rounded-lg flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-500"
              style={{ width: 44, height: 44, border: "1px solid rgba(255,255,255,0.10)" }}
            >
              <img src={logo} alt="Przestrzeń Apps" className="w-full h-full object-cover scale-110" draggable="false" />
            </span>
            <span className="font-display text-[1rem] tracking-[0.04em] text-white-warm">
              Przestrzeń <em className="not-italic text-amber">Apps</em>
            </span>
          </a>

          <p className="font-body text-sm leading-relaxed" style={{ color: "rgba(242,232,216,0.5)", maxWidth: "26ch" }}>
            {c.footer.tagline[lang]}
          </p>

          <p className="font-mono text-[10px] tracking-[0.22em] uppercase mt-6" style={{ color: "rgba(242,232,216,0.25)" }}>
            {c.footer.location[lang]}
          </p>

          <p className="font-body text-[11px] mt-3" style={{ color: "rgba(242,232,216,0.22)" }}>
            {SITE.legal[lang]}
          </p>
        </div>

        <div>
          <p className="font-body text-[10px] tracking-[0.28em] uppercase mb-6" style={{ color: "rgba(242,232,216,0.28)" }}>
            {c.footer.nav_header[lang]}
          </p>
          <nav className="flex flex-col gap-3.5">
            {c.nav.links.map(({ href, pl, en }) => (
              <a
                key={href}
                href={`/${href}`}
                className="font-body text-sm w-fit transition-colors duration-200"
                style={{ color: "rgba(242,232,216,0.5)" }}
                onMouseEnter={(e) => { e.currentTarget.style.color = "#7CC4D8"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(242,232,216,0.5)"; }}
              >
                {lang === "pl" ? pl : en}
              </a>
            ))}
            <Link
              to="/blog"
              className="font-body text-sm w-fit transition-colors duration-200"
              style={{ color: "rgba(242,232,216,0.5)" }}
              onMouseEnter={(e) => { e.currentTarget.style.color = "#7CC4D8"; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(242,232,216,0.5)"; }}
            >
              Blog
            </Link>
          </nav>
        </div>

        <div>
          <p className="font-body text-[10px] tracking-[0.28em] uppercase mb-6" style={{ color: "rgba(242,232,216,0.28)" }}>
            {c.footer.con_header[lang]}
          </p>

          <a href={`mailto:${SITE.email}`} className="font-body text-sm text-white-warm hover:text-amber transition-colors duration-200 block">
            {SITE.email}
          </a>
          <a href={`tel:${SITE.phone}`} className="font-body text-sm text-white-warm hover:text-amber transition-colors duration-200 block mt-2">
            {SITE.phoneDisplay}
          </a>
          <p className="font-body text-sm mt-1.5" style={{ color: "rgba(242,232,216,0.4)" }}>
            {c.footer.response[lang]}
          </p>

          <div className="flex flex-wrap gap-3 mt-8">
            {SOCIALS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="font-mono text-[10px] tracking-[0.18em] uppercase px-3.5 py-2 rounded-lg transition-all duration-200"
                style={{ border: "1px solid rgba(255,255,255,0.08)", color: "rgba(242,232,216,0.4)" }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(124,196,216,0.45)"; e.currentTarget.style.color = "#7CC4D8"; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; e.currentTarget.style.color = "rgba(242,232,216,0.4)"; }}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-6 lg:mx-20 h-px" style={{ background: "rgba(255,255,255,0.06)" }} />
      <div className="max-w-7xl mx-auto px-6 lg:px-20 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-4 flex-wrap justify-center sm:justify-start">
          <p className="font-body text-xs" style={{ color: "rgba(242,232,216,0.3)" }}>
            © {new Date().getFullYear()} Przestrzeń Apps
          </p>
          <button
            onClick={openPolicy}
            className="font-body text-xs transition-colors duration-200"
            style={{ color: "rgba(242,232,216,0.22)" }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "rgba(200,121,65,0.65)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(242,232,216,0.22)"; }}
          >
            {lang === "pl" ? "Polityka prywatności" : "Privacy Policy"}
          </button>
        </div>

        <span
          aria-hidden="true"
          style={{
            fontFamily: '"Cormorant Garamond", Georgia, "Times New Roman", serif',
            fontWeight: 300,
            fontSize: "1rem",
            letterSpacing: "0.06em",
            background: "linear-gradient(135deg, #C87941 0%, #7CC4D8 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            opacity: 0.48,
            userSelect: "none",
            lineHeight: 1,
          }}
        >
          間
        </span>

        <p className="font-mono text-[10px] tracking-[0.22em] uppercase" style={{ color: "rgba(242,232,216,0.18)" }}>
          Designed & Built in Poznań
        </p>
      </div>
    </footer>
  );
}